// Common API's
const GetWorkOrderTypesAndCategories = 'Common/GetWorkOrderTypesAndCategories'
const GetWorkorderStages = 'Common/GetWorkorderStages'
const GetCountryStates = 'Common/GetCountryStates'
const GetDocumentTemplateData = 'Common/GetDocumentTemplateData'
const GetDocumentTemplateByCode = 'Common/GetDocumentTemplateByCode'

// Dashboard API's
const GetCustomerWorkorders = 'Dashboard/GetCustomerWorkorders'
const FilterWorkorders = 'Dashboard/FilterWorkorders'
const GetVesselDashboard = 'getVesselDashboard'

// Company API's
const GetPartiesOfCurrentUser = 'Company/GetPartiesOfCurrentUser'
const GetPartiesByName = 'Company/GetPartiesByName'
const GetPartiesByPartyId = 'Company/GetPartiesByPartyId'
const RefreshWorkorderEntities = 'RefreshWorkorderEntities'

const CreateCompany = 'Company/CreateCompany'
const GetAllCompanies = 'Company/GetAllCompanies'
const ValidateClient = 'Company/ValidateClient'
const ValidateWorkorderCreation = 'ValidateWorkorderCreation'
const GetCorporationsByPartyId = 'Company/GetCorporationsByPartyId'
const AgentWorkorderEntities = 'LTC/DL/GetCorporationsByCompanyId'

// Workorders API's
const GetBaseWorkOrderData = 'GetBaseWorkOrderData'
const CreateWorkorder = 'CreateWorkorder'
const UpdateWorkorderData = 'UpdateWorkorderData'
const GetWorkorderById = 'GetWorkorderById'
const UpdateWorkorder = 'UpdateWorkorder'
const RemoveWorkorderDocument = 'FileUpload/RemoveWorkorderDocument'
const RequestMoreInfo = 'RequestMoreInfo'
const GetInvoiceDocument = 'GetInvoiceDocument'
const UpdateNeedMoreInfoStatus = 'UpdateNeedMoreInfoStatus'
const CancelWorkorder = 'CancelWorkorder'
const ArchivedWorkorder = 'ArchivedWorkorder'
const RejectWorkorder = 'RejectWorkorder'
const ResendDocusignEmail = 'ResendDocusignEmail'
const GetAuthorizationDocument = 'GetAuthorizationDocument'
const ValidateVesselDetails = 'ValidateVesselDetails'
const GetWorkOrderFilesByFileId = 'FileUpload/GetWorkOrderFilesByFileId'
const GetVesselOwnersData = 'GetVesselOwnersData'
const GetVendorsData = 'GetVendorsData'
const GetBillableVoyAges = 'GetBillableVoyAges'
const GetUpdatedBillableVoyages = 'GetUpdatedBillableVoyages'
const GetCompanyAddressdetails = 'GetCompanyAddressdetails'
const GetAllProducts = 'GetAllProducts'
const GetCurrentQBbyCompany = 'GetCurrentQBbyCompany'
const GetERBPCListByIMONumber = 'GetERBPCListByIMONumber'
const GetPreviewDocument = 'PreviewAuthorizationDocument'
// Workorder Comments Api's
const GetWorkorderComments = 'WorkorderComment/GetWorkorderComments'
const CreateComment = 'WorkorderComment/CreateComment'

// API's
const GetAllVesselsByAccountId = 'GetAllVesselsByAccountId'
const GetVesselByIMONumber = 'GetVesselByIMONumber'
const GetSoftwareVersionPClist = 'GetSoftwareVersionPClist'
const ResendEmails = 'ResendEmails'
const UpdateBillingPrefix = 'UpdateBillingPrefix'
const UpdateResendEmail = 'ResendEmail'
const GetAgreementDocument = 'GetAgreementDocument'
const PreviewAgreementDocument = 'PreviewAgreementDocument'
const RegenarateAuthorizationLetter = 'RegenarateAuthorizationLetter'
const RegenerateAuthorizationLetter = 'RegenerateAuthorizationLetter'
//RLM
const GetListFiles = "GetListFiles"
const GetAllActiveVaultsForUser = "GetActiveVaultsForUser"
const DownloadFile = "DownloadFile"
const GetCompanyAddress = "Company/GetCompanyAddress"
const GetLastModifiedFiles = "GetLastModifiedFiles"
const GetCorporationsByNameOrId = "Company/GetCorporationsByNameOrId"
const GetDashBoardData = "Dashboard/GetDashBoardData"
const GetCorporationsByEntityIdOrName = "Company/GetCorporationsById"
export const ApiUrls = {
  GetWorkOrderTypesAndCategories,
  GetWorkorderStages,
  GetCountryStates,
  GetDocumentTemplateData,

  GetCustomerWorkorders,
  FilterWorkorders,
  GetVesselDashboard,
  ValidateClient,
  GetPartiesByName,
  GetPartiesByPartyId,
  CreateCompany,
  ValidateWorkorderCreation,

  GetBaseWorkOrderData,
  CreateWorkorder,
  UpdateWorkorderData,
  GetWorkorderById,
  UpdateWorkorder,
  RemoveWorkorderDocument,
  RequestMoreInfo,
  GetInvoiceDocument,
  UpdateNeedMoreInfoStatus,
  CancelWorkorder,
  ArchivedWorkorder,
  RejectWorkorder,
  ResendDocusignEmail,
  ValidateVesselDetails,
  GetWorkOrderFilesByFileId,
  GetVesselOwnersData,
  GetVendorsData,
  GetBillableVoyAges,
  GetUpdatedBillableVoyages,
  GetCompanyAddressdetails,
  GetAllProducts,
  GetCurrentQBbyCompany,
  GetWorkorderComments,
  CreateComment,
  GetAgreementDocument,
  PreviewAgreementDocument,
  GetAuthorizationDocument,
  GetAllVesselsByAccountId,
  GetVesselByIMONumber,
  ResendEmails,
  UpdateBillingPrefix,
  UpdateResendEmail,
  RegenarateAuthorizationLetter,
  GetERBPCListByIMONumber,
  GetSoftwareVersionPClist,
  GetListFiles,
  GetAllActiveVaultsForUser,
  DownloadFile,
  GetCompanyAddress,
  GetLastModifiedFiles,
  GetCorporationsByPartyId,
  AgentWorkorderEntities,
  GetDocumentTemplateByCode,
  GetAllCompanies,
  GetPartiesOfCurrentUser,
  RegenerateAuthorizationLetter,
  RefreshWorkorderEntities,
  GetPreviewDocument,
  GetCorporationsByEntityIdOrName,
  GetCorporationsByNameOrId,
  GetDashBoardData
}